import { Component, Input } from '@angular/core';
import { ListPageColumnComponent } from 'design-system';
import { CommonModule } from '@angular/common';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'cus-chip-listino',
  imports: [CommonModule, MatChipsModule],
  templateUrl: './chip-listino.html',
  styleUrl: './chip-listino.scss',
})
export class ChipListino extends ListPageColumnComponent {

  @Input() listino: string;

  ngOnInit() {
    if(this.itemData && this.infoColumn) {
      this.listino = this.itemData[this.infoColumn.columnNameDef];
    }
  }

  getCssClass() {
    switch (this.listino) {
      case 'Oil':
        return 'oil';
      case 'NonOil': 
        return 'non-oil';
      case 'agenti': 
        return 'listino-agenti';
      default:
        return 'listino-unknown';
    }
  }

  getLabel() {
    switch (this.listino) {
      case 'Oil': 
        return 'Oil';
      case 'NonOil': 
        return 'Non Oil';
      case 'agenti': 
        return 'Agente';
      default:
        return 'Libero';
    }
  }
}
